module.exports = __webpack_public_path__ + "public/img/circle-x.ee287cf6.png";